import { Injectable } from '@angular/core';
import { BehaviorSubject } from "rxjs/BehaviorSubject";

import { emptyInvoicingService, IInvoicingService } from "../model/invoicing-service";
import { LoginService } from "./login.service";
import { InvoicingServiceService } from "./invoicing-service.service";
import { AsyncSubject } from 'rxjs/AsyncSubject';

@Injectable()
export class MyInvoicingServicesService {

  /**
   * My InvoicingServices
   *
   * @type {AsyncSubject<IInvoicingService[]>}
   */
  private myInvoicingServicesSource = new AsyncSubject<IInvoicingService[]>();

  /**
   * My InvoicingServices
   *
   * @type {Observable<IInvoicingService[]>}
   */
  myInvoicingServices$ = this.myInvoicingServicesSource.asObservable();

  /**
   * My InvoicingService (same identifier)
   *
   * @type {BehaviorSubject<IInvoicingService>}
   */
  private myInvoicingServiceSource = new BehaviorSubject<IInvoicingService>(emptyInvoicingService);

  /**
   * My InvoicingService (same identifier)
   *
   * @type {Observable<IInvoicingService>}
   */
  myInvoicingService$ = this.myInvoicingServiceSource.asObservable();

  /**
   * Default InvoicingServices
   *
   * @type {AsyncSubject<IInvoicingService>}
   */
  private defaultInvoicingServiceSource = new BehaviorSubject<IInvoicingService>(emptyInvoicingService);

  /**
   * Default InvoicingServices
   *
   * @type {Observable<IInvoicingService>}
   */
  defaultInvoicingService$ = this.defaultInvoicingServiceSource.asObservable();

  constructor(
    private invoicingServiceService: InvoicingServiceService,
    private loginService: LoginService,
  ) {
    this.invoicingServiceService.getInvoicingServicesAsAuthorized()
      .subscribe(invoicingServices => {
        this.refreshInvoicingServices(invoicingServices);
        });
  }

  refreshInvoicingServices(invoicingServices: IInvoicingService[]) {
    this.myInvoicingServicesSource.next(invoicingServices);
    this.myInvoicingServicesSource.complete();
    this.setDefaultInvoicingService(invoicingServices);
    this.setMyInvoicingService(invoicingServices);
  }

  setNewInvoicingService(invoicingService: IInvoicingService) {
    this.myInvoicingServicesSource.subscribe(invoicingServices => {
      invoicingServices.push(invoicingService);
      this.refreshInvoicingServices(invoicingServices);
    });
  }

  private setDefaultInvoicingService(invoicingServices: IInvoicingService[]) {
    if (invoicingServices.length === 1) {
      this.defaultInvoicingServiceSource.next(invoicingServices[0]);
    }else if (invoicingServices.length > 1) {
      if (this.loginService.getPerson().preferences) {
        let invoicingService = invoicingServices.find(
          item => { return item.identifier == this.loginService.getPerson().preferences.invoicingService }
        );
        this.defaultInvoicingServiceSource.next(invoicingService);
      }
    }
  }

  private setMyInvoicingService(invoicingServices: IInvoicingService[]) {
    let invoicingService = invoicingServices.find(
      item => { return item.identifier == this.loginService.getPerson().identifier }
    );

    if (invoicingService && invoicingService != this.myInvoicingServiceSource.getValue()) {
      this.myInvoicingServiceSource.next(invoicingService);
    }
  }

  /**
   *
   * @param {IInvoicingService} invoicingService
   */
  updateDefault(invoicingService: IInvoicingService){
    this.defaultInvoicingServiceSource.next(invoicingService);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/my-invoicing-services.service.ts